export enum PaymentFrequencies {
  Monthly = 'monthly',
  Annual = 'annual'
}
